import animationsConfig from "../json/animations.json";

export let music;

export const stopMusic = () => {
    if (music != null) {
        music.stop();
    }

    music = null;
}

export const playMusic = (animationData) => {
    if (!animationData.Music)
        return;

    stopMusic();
    const link = `${animationsConfig.music_url}/${animationData.Music}.ogg`;

    let instance = null;
    instance = music = new Howl({
        src: link,
        loop: true,
        volume: animationsConfig.default_music_volume / (5 * 100),
        buffer: false,
        onload: function() {
            if (instance != music) {
                this.stop();
            }
            else {
                this.play();
            }
        },
    });

    music.link = link;
}